export default __webpack_public_path__ + "static/media/coupon.c7757ec7.svg";